/**
 * EL LOBBY DE UNA SALA HOSTEADA (T5) — a quién esperamos, cuánto queda, y quién arranca.
 *
 * Español NEUTRO, sin voseo, como todo este catálogo.
 */
export default {
  title: 'Sala',
  code: 'Código',
  expires: 'La invitación vence en',
  expired: 'La invitación venció y no llegaron dos. Cierra la sala y abre otra.',
  /* Lo que un GET fallado prueba es que no se pudo preguntar — nunca que se fueron todos. */
  stale: 'No se pudo leer la sala: esto es lo último que se supo.',
  /* «No hay a quién preguntarle» NO es «no vino nadie»: dos pestañas de un navegador no pasan por el
     plano de coordinación, así que ahí no hay roster que exista. */
  no_plane: 'Esta sala no pasa por el plano: no hay lista de invitados que leer.',
  host: 'anfitrión',

  /* Los cuatro estados del PLANO. Son cuatro cosas distintas y por eso son cuatro palabras. */
  state_invited: 'invitado',
  state_accepted: 'aceptó',
  state_connected: 'conectado',
  state_left: 'se fue',
  /* Y el quinto, que no es del plano: tener CUERPO. Un canal abierto es alguien que todavía puede estar
     leyendo el menú, y el que invita necesita distinguirlos para saber si puede arrancar. */
  state_in_field: 'en el campo',

  bodies: '{n} en el campo — {sides} por bando',
  start: 'Arrancar la ronda',
  cut: 'Cortar la sala',
  need_two: 'Hacen falta dos, uno por bando',
  room_over: 'El plano dio la sala por terminada ({status}).',
  /* El fin de ronda, dirigido AL ANFITRIÓN: los demás lo ven en el marcador, y el que hospeda es el
     único que tiene algo que decidir después. */
  round_over: 'Terminó la ronda. Puedes arrancar otra, o cortar la sala.',
};
